var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("DefaultHeader"),
      _c(
        "div",
        { staticClass: "app-body" },
        [
          _c(
            "AppSidebar",
            { ref: "sidebar", attrs: { fixed: "" } },
            [
              _c("SidebarHeader"),
              _c("SidebarForm"),
              _c("SidebarNav", { attrs: { navItems: _vm.permissibleNav } }),
              _c("SidebarFooter"),
              _c("SidebarMinimizer"),
            ],
            1
          ),
          _c(
            "main",
            { staticClass: "main" },
            [
              _c("Breadcrumb", { attrs: { list: _vm.list } }),
              _c(
                "div",
                { staticClass: "container-fluid" },
                [_c("router-view")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("DefaultFooter"),
      _c("profile-edit-modal"),
      _c("snapshot-modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }